import { render, staticRenderFns } from "./adminVero.vue?vue&type=template&id=4cf56ca5"
import script from "./adminVero.vue?vue&type=script&lang=js"
export * from "./adminVero.vue?vue&type=script&lang=js"
import style0 from "./adminVero.vue?vue&type=style&index=0&id=4cf56ca5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports